export const AUTH_API_URLS = {
  LOGIN: "/AuthServer/v1/auth/login",
  LOGOUT: "/AuthServer/v1/auth/logout",
  REFRESH_TOKEN: "/AuthServer/v1/auth/generateAccessToken",
};
